export default function NoteContent({ category }) {
    if (!category) {
        return (
            <main className="flex-1 bg-[#141414] flex flex-col min-w-0">
                <div className="flex-1 flex items-center justify-center">
                    <div className="text-center">
                        <p className="text-[#8E8E93] text-lg">Select a note to view</p>
                    </div>
                </div>
            </main>
        );
    }

    // Handle Start Here note
    if (category.isStartHere) {
        return (
            <main className="flex-1 bg-[#141414] flex flex-col min-w-0">
                <div className="h-[52px] flex items-center justify-between px-6 pt-2">
                    <div className="w-20"></div>
                    <div className="text-[#8E8E93] text-[12px] font-medium text-center">
                        {new Date().toLocaleDateString('en-US', { 
                            month: 'long', 
                            day: 'numeric', 
                            year: 'numeric' 
                        }) + ' at ' + new Date().toLocaleTimeString('en-US', { 
                            hour: 'numeric', 
                            minute: '2-digit',
                            hour12: true 
                        })}
                    </div>
                    <div className="w-20"></div>
                </div>

                <div className="flex-1 overflow-y-auto px-12 py-6 max-w-[850px] mx-auto w-full note-content">
                    <h1 className="text-[32px] font-bold text-white mb-6 leading-tight">Want to romanticise Delhi on Instagram?</h1>
                    <div className="text-[17px] text-[#EBEBF5] leading-[1.6] space-y-6">
                        <p>
                            From cholle bhature to cafes to hidden spots, I've got your weekend plans sorted. This is a local's guide to falling in love with Delhi.
                        </p>
                        <div className="flex items-start gap-3">
                            <div className="w-6 h-6 bg-[#FFB400] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                                <i className="ph ph-check text-black text-sm font-bold"></i>
                            </div>
                            <p className="text-[17px] text-[#EBEBF5]">
                                Stop getting lost on Google Maps. This city is not for beginners.
                            </p>
                        </div>
                        <div className="w-full max-w-2xl overflow-hidden border border-black/10 my-6">
                            <img 
                                src="/header.png" 
                                alt="Delhi skyline" 
                                className="w-full h-auto object-cover"
                            />
                        </div>
                        <div className="h-20"></div>
                    </div>
                </div>
            </main>
        );
    }

    const formatDate = () => {
        const now = new Date();
        return now.toLocaleDateString('en-US', { 
            month: 'long', 
            day: 'numeric', 
            year: 'numeric' 
        }) + ' at ' + now.toLocaleTimeString('en-US', { 
            hour: 'numeric', 
            minute: '2-digit',
            hour12: true 
        });
    };

    const handleShare = () => {
        const tweet = encodeURIComponent(`local food spots to your weekend date plans.\n\neverything you need to know about delhi. \n \ncheck out: https://dilli.wiki`);
        const twitterIntentUrl = `https://twitter.com/intent/tweet?text=${tweet}`;
        window.open(twitterIntentUrl, '_blank');
    };

    return (
        <main className="flex-1 bg-[#141414] flex flex-col min-w-0">
            <div className="h-[52px] flex items-center justify-between px-6 pt-2">
                <div className="w-20"></div>
                
                <div className="text-[#8E8E93] text-[12px] font-medium text-center">
                    {formatDate()}
                </div>
                
                <div className="flex items-center gap-6">
                    <i className="ph ph-text-aa text-[#FFB400] text-xl hover:opacity-80 transition-opacity"></i>
                    <i className="ph ph-check-circle text-[#FFB400] text-xl hover:opacity-80 transition-opacity"></i>
                    <i className="ph ph-camera text-[#FFB400] text-xl hover:opacity-80 transition-opacity"></i>
                    <i className="ph ph-pen-nib text-[#FFB400] text-xl hover:opacity-80 transition-opacity"></i>
                    <div className="w-[1px] h-4 bg-[#38383A]"></div>
                    <i 
                        className="ph ph-export text-[#FFB400] text-xl cursor-pointer hover:opacity-80 transition-opacity"
                        onClick={handleShare}
                    ></i>
                </div>
            </div>

            <div className="flex-1 overflow-y-auto px-12 py-6 max-w-[850px] mx-auto w-full note-content">
                <h1 className="text-[32px] font-bold text-white mb-6 leading-tight">
                    {category.emoji && <span className="mr-3">{category.emoji}</span>}
                    {category.name}
                </h1>

                <div className="text-[17px] text-[#EBEBF5] leading-[1.6] space-y-6">
                    {category.places && category.places.length > 0 ? (
                        <>
                            {category.places.map((place, index) => (
                                    <div key={place.id || index} className="flex gap-4 group">
                                        <span className="text-[#EBEBF5] mt-0.5">{index + 1}.</span>
                                        <div className="flex-1 border-b border-[#38383A] pb-4 last:border-0">
                                            <a 
                                                href={place.href} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="font-semibold text-[#FFB400] underline decoration-[#FFB400]/30 hover:decoration-[#FFB400] underline-offset-4 transition-all"
                                            >
                                                {place.name}
                                            </a>
                                        </div>
                                    </div>
                            ))}
                        </>
                    ) : (
                        <p className="text-[#8E8E93]">No places added yet.</p>
                    )}

                    <div className="h-20"></div>
                </div>
            </div>

            <div className="h-10 flex items-center justify-center text-[#8E8E93] text-sm opacity-50">
            </div>
        </main>
    );
}
